import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class campusServices extends ApiBaseService {
    constructor(public http: HttpClient) {
        super(http, '/campus');
    }

    checkNameExists(name: string, id?: boolean | number): Observable<any> {
        const campusId = id ? id : null;
        const params = { name, campusId };
        return this.http.get(`${environment.apiUrl}/campus/check`, {
            params,
        });
    }
}
